<div class="form-group {{ customClass }}" *ngIf="loaded; else loading">
    <label *ngIf="label && !suppressLabel" for="dp" class="control-label" [ngClass]="{ 'font-weight-bold': labelBold }">
      {{ label | translate }}
      <i *ngIf="tooltip" class="fal fa-question-circle" ngbTooltip="{{ tooltip | translate }}"></i>
      <span *ngIf="footnote" class="ml-1">*</span>
    </label>
    <div class="input-group">
      <input
        class="form-control input-date invisible position-absolute w-0"
        placeholder="{{dateUtilService.dateFormat}}"
        name="dp"
        #dpInput
        ngbDatepicker
        #d="ngbDatepicker"
        [minDate]="minInitialDate"
        [maxDate]="maxDatePickerDate"
        [startDate]="value"
        [(ngModel)]="value"
        [readonly]="true"
        [disabled]="disabled"
        (dateSelect)="dateSelected($event); d.close(); dpInput.blur()"
        [placement]="placement"
				[positionTarget]="positionTarget"
        [container]="container"
        [firstDayOfWeek]="firstDayOfWeek"
      />
      <input
        class="form-control input-date {{extraInputClass}}"
        [style.padding-right]="(clearable && value) ? '2rem' : null"
        placeholder="{{dateUtilService.dateFormat}}"
        (click)="!renderStatic ? (!userWriteDate? d.toggle() : undefined) : undefined"
        [value]="value ? (dateUtilService.createDateFromNgbDate(value) | date: dateUtilService.dateFormat) : ''"
        [readonly]="!userWriteDate"
        [disabled]="disabled"
        (blur)="userWriteDate ? changeDateValue($event) : undefined"
      />
      <button
        *ngIf="clearable && value"
        class="btn gung-date-clear-btn"
        (click)="clearDate()"
        type="button"
        [disabled]="disabled"
        tabindex="-1">
        <i class="fal fa-times"></i>
      </button>
      <div class="input-group-append" *ngIf="!renderStatic">
        <button class="btn btn-outline-secondary calendar {{extraBtnClass}}" (click)="d.toggle()" type="button" [disabled]="disabled">
          <i class="fal fa-calendar-alt"></i>
        </button>
      </div>
    </div>
  </div>
  
  <ng-template #loading>
    <div *ngIf="!anyError; else showError">LOADING...</div>
    <ng-template #showError>
      <button class="btn btn-sm btn-danger btn-default" (click)="openErrorModal()" translate>ERROR</button>
    </ng-template>
  </ng-template>
  